import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  // {
  //   navCap: 'Home',
  // },
  // {
  //   displayName: 'Inicio',
  //   iconName: 'basket',
  //   route: '/dashboards/dashboard1',
  // },
  // {
  //   displayName: 'Formulario',
  //   iconName: 'home',
  //   route: '/mforms/index'
  // },
  {
    displayName: 'Mantenimiento de metas',
    iconName: 'target',
    route: '/goals/index',
    moduleCode: 'goals'
  },
  {
    displayName: 'Seguimiento de Metas - Nuevos',
    iconName: 'chart-bar',
    route: '/goals-report/index',
    moduleCode: 'goals-report'
  },
  {
    displayName: 'Mantenimiento de productos',
    iconName: 'package',
    route: '/products/index',
    moduleCode: 'products'
  },
  {
    displayName: 'Presupuesto Proyectado',
    iconName: 'calculator',
    route: '/presupuesto/index',
    moduleCode: 'presupuesto'
  },
  {
    displayName: 'Estado de Resultados',
    iconName: 'receipt',
    route: '/estado-de-resultados',
    moduleCode: 'estado-de-resultados'
  },
  {
    displayName: 'Acumulado Ventas por Vendedor',
    iconName: 'trending-up',
    route: '/acumulado-ventas-vendedor/index',
    moduleCode: 'acumulado-ventas-vendedor'
  },
  {
    displayName: 'Seguridad',
    iconName: 'shield',
    children: [
      {
        displayName: 'Roles',
        iconName: 'user-check',
        route: '/security/roles',
        moduleCode: 'security.roles'
      },
      {
        displayName: 'Permisos',
        iconName: 'key',
        route: '/security/permissions/index',
        moduleCode: 'security.permissions'
      },
      {
        displayName: 'Usuarios',
        iconName: 'users',
        route: '/security/users/index',
        moduleCode: 'security.users'
      }
    ]
  },
  {
    displayName: 'Recursos Humanos',
    iconName: 'users',
    children: [
      {
        displayName: 'Mi Jornada',
        iconName: 'clock',
        route: '/hr/mi-jornada',
        moduleCode: 'hr.mi-jornada'
      },
      {
        displayName: 'Empleados',
        iconName: 'user',
        route: '/hr/empleados',
        moduleCode: 'hr.empleados'
      },
      {
        displayName: 'Calendario',
        iconName: 'calendar',
        route: '/hr/calendario',
        moduleCode: 'hr.calendario'
      },
      {
        displayName: 'Catálogos',
        iconName: 'list',
        route: '/hr/catalogos',
        moduleCode: 'hr.catalogos'
      }
    ]
  },
  {
    displayName: 'Reportes',
    iconName: 'chart-pie',
    children: [
      {
        displayName: 'Reporte de Jornadas',
        iconName: 'chart-bar',
        route: '/reports/workday',
        moduleCode: 'reports.workday'
      }
    ]
  }
];
